import {TrendingLandsMarketItems} from '#/components/market-data/trending-lands-market-items';
import {TrendingMarketItemButton} from '#/components/market-data/trending-market-item-button';
import {SyntheticMarketDataRange} from '#/types/synthetic-market-data-range';
import {FunctionComponent} from 'react';
import {useTranslation} from 'react-i18next';

export const TrendingMarketData: FunctionComponent = () => {
  const {t} = useTranslation('translation');
  const range: SyntheticMarketDataRange = 'monthly';

  return (
    <section className={'select-none @container/marketDataSection group/trending-market-data-section'}>
      <h2 className='text-2xl text-blue-600 font-bold px-5 md:px-10 @screen2xl/home:!pl-homeMaxScreen2xl mb-4'>
        {t(`pages.home.trending.title.${range}`)}
      </h2>
      <TrendingLandsMarketItems
        ItemComponent={TrendingMarketItemButton}
        itemComponentProps={{
          thumbnailMode: 'empty',
          range,
        }}
      />
    </section>
  );
};
